import _toArray from "@babel/runtime/helpers/toArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _compact from "lodash/compact";
import "core-js/modules/es6.regexp.split.js";
import "core-js/modules/es6.array.slice.js";
import "core-js/modules/es6.object.keys.js";
import "core-js/modules/es6.array.map.js";
/**
 * Wrapper function for the `policies#readField` API from apollo/client
 * in order to provide type safety for the field being accessed and the
 * return type.
 */
export var readField = function readField(context) {
  for (var _len = arguments.length, restArgs = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    restArgs[_key - 1] = arguments[_key];
  }
  return (
    // @ts-expect-error: The compiler doesn't understand this correctly, but the
    // `ReadFieldFunction` type is correct, so this will typecheck and function
    // correctly for callers.
    context.readField.apply(context, restArgs)
  );
};

/**
 * Utility function that wraps the policies#readField API in order to enable reading of multiple fields at once.
 */
export var readFields = function readFields(context, fields, from) {
  return fields.reduce(function (acc, field) {
    return _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, field, context.readField(field, from)));
  }, {});
};

/**
 * Utility function that wraps the policies#readField in order to support reading a nested field property.
 * Ex. readNestedField(context, 'manager.name', {__ref: 'Employee:1'});
 */
export function readNestedField(context, nestedFields, from) {
  var _readField;
  var _nestedFields$split = nestedFields.split('.'),
    _nestedFields$split2 = _toArray(_nestedFields$split),
    field = _nestedFields$split2[0],
    restFields = _nestedFields$split2.slice(1);
  var result = (_readField = readField(context, field, from)) !== null && _readField !== void 0 ? _readField : null;
  if (restFields.length === 0 || !result) {
    return result;
  }
  return readNestedField(context, restFields.join('.'), result);
}

/**
 * Utility function that wraps the policies#readField API in order to reduce a returned collection of store objects under
 * a given key. Since the store only returns arrays, it is often desired to take the returned array and turn it into a dictionary keyed
 * by some identifier
 */
export var groupReferencesByKey = function groupReferencesByKey(context, references, key) {
  return references.reduce(function (acc, listItemRef) {
    var fieldValueForKey = context.readField(key, listItemRef);
    return _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, fieldValueForKey, listItemRef));
  }, {});
};

/**
 * Utility function to combine multiple type policy schemas into one so that the combined type policies and schema definitions
 * can be supplied to the Apollo client config. Detects duplicate fields and types in type policy definitions and throws an error
 * telling the user that duplicate fields are not supported.
 */
export var combineTypePolicies = function combineTypePolicies(policySchemas) {
  var typePolicies = {};
  policySchemas.forEach(function (_ref) {
    var typePoliciesConfig = _ref.typePolicies;
    Object.keys(typePoliciesConfig).forEach(function (typename) {
      var _typePolicy$fields;
      var typePolicy = typePoliciesConfig[typename];
      var fieldPolicies = (_typePolicy$fields = typePolicy.fields) !== null && _typePolicy$fields !== void 0 ? _typePolicy$fields : {};
      if (!typePolicies[typename]) {
        typePolicies[typename] = {};
      }
      var existingTypePolicy = typePolicies[typename];
      Object.keys(typePolicy).forEach(function (typePolicyKey) {
        if (typePolicyKey === 'fields') {
          if (!existingTypePolicy.fields) {
            existingTypePolicy.fields = {};
          }
          var existingFieldPolicies = existingTypePolicy.fields;
          Object.keys(fieldPolicies).forEach(function (fieldPolicyKey) {
            if (existingFieldPolicies[fieldPolicyKey]) {
              throw new Error("Apollo Type Policy Conflict: Error combining field policies key \"".concat(fieldPolicyKey, "\" for typename \"").concat(typename, "\". Please resolve this conflict by providing only one field policy for \"").concat(fieldPolicyKey, "\" in your local application code."));
            }
            existingFieldPolicies[fieldPolicyKey] = fieldPolicies[fieldPolicyKey];
          });
        } else if (existingTypePolicy[typePolicyKey]) {
          throw new Error("Apollo Type Policy Conflict: Error combining type policies key \"".concat(typePolicyKey, "\" for typename \"").concat(typename, "\". Please resolve this conflict by providing only one value of \"").concat(typePolicyKey, "\" in your local application code."));
        } else {
          existingTypePolicy[typePolicyKey] = typePolicy[typePolicyKey];
        }
      });
    });
  });
  return {
    typeDefs: _compact(policySchemas.map(function (policySchema) {
      return policySchema.typeDefs;
    })),
    typePolicies: typePolicies
  };
};